export const APP_CONFIG = {
  VERSION: '1.0.0',
};

export const datadogConfig = {
  defaultPrivacyLevel: 'mask-user-input',
};
